export const Label = ({ label, required }: { label: string; required?: boolean }) => (
    <div>
        {label}
        {required && <span style={{ color: "red" }}> *</span>}
    </div>
);
